var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-details-edit"},[(_vm.user)?_c('user-details-edit-card',{attrs:{"user":_vm.user,"title":_vm.$t('candidate.edit.details', {name: _vm.candidateFullName})},on:{"submit":_vm.onSubmit}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }